import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["getCopyText", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { CopyIcon } from '@chakra-ui/icons';
import { IconButton, forwardRef, useToast } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
export var CopyButton = forwardRef(function (props, ref) {
  var getCopyText = props.getCopyText,
      onClick = props.onClick,
      rest = _objectWithoutProperties(props, _excluded);

  var toast = useToast();

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var handleClick = useCallback(function (e) {
    var text = getCopyText();

    if (onClick) {
      onClick(e);
    }

    navigator.clipboard.writeText(text);
    toast({
      title: t('common:copied', '已複製'),
      status: 'success',
      position: 'top',
      isClosable: true,
      duration: 2000
    });
  }, [getCopyText, toast, t, onClick]);
  return /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
    ref: ref,
    variant: "ghost",
    "aria-label": "Copy",
    icon: /*#__PURE__*/_jsx(CopyIcon, {
      e2eid: "Button_CopyButton_CopyIcon"
    }),
    onClick: handleClick
  }, rest), {}, {
    e2eid: "Button_CopyButton_IconButton"
  }));
});